// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popup-body .btn-style-outline-secondary[data-v-8d7f7ca4]{\n\tcolor: #B1A781;\n\tborder: 1px solid #B1A781;\n\tbackground-color: transparent;\n}\n.popup-body .btn-style-outline-secondary[data-v-8d7f7ca4]:hover,\n.popup-body .btn-style-outline-secondary[data-v-8d7f7ca4]:focus {\n\tcolor: #FFF;\n\tborder: 1px solid #B1A781;\n\tbackground-color: #B1A781;\n}\n", ""]);
// Exports
module.exports = exports;
